import styled from 'styled-components'
import Icon from './Icon'

const UserIcon = styled(Icon).attrs({
  type: 'x',
})``

export default UserIcon
